export const COMMON_PROPS_INPUT = {
    classExtra: {
        type: String,
        default: ''
    },
    value: {
        type: String,
        default: ''
    },
    valueModel: {
        type: String,
        default: ''
    },
    nameRef: {
        type: String,
        required: true,
        default: ''
    },
    eventModel: {
        type: [String, Boolean, Array],
        default: ''
    },
    required: {
        type: Boolean,
        default: true
    },
    clearable: {
        type: Boolean,
        default: true
    },
    placeholder: {
        type: String,
        default: ''
    },
    maxlength: {
        type: Number,
        default: 255
    },
    minlength: {
        type: Number,
        default: 0
    },
    label: {
        type: String,
        default: ''
    },
    disabled: {
        type: Boolean,
        default: false
    },
    readonly: {
        type: Boolean,
        default: false
    },
    outlined: {
        type: Boolean,
        default: false
    },
    ruleFormRef: {
        type: Object,
        default: () => {
            return {}
        }
    },

};
